module.exports = __webpack_public_path__ + "img/book_900.7ae42401.png";